import { render } from "./MenuColor.vue?vue&type=template&id=5c50f947"
import script from "./MenuColor.vue?vue&type=script&lang=js"
export * from "./MenuColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__